"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const javascript_time_ago_1 = __importDefault(require("javascript-time-ago"));
const ru_1 = __importDefault(require("javascript-time-ago/locale/ru"));
const createRootElement_1 = require("./createRootElement");
const HeaderPresenter_1 = __importDefault(require("./presenters/header/HeaderPresenter"));
const SidebarPresenter_1 = __importDefault(require("./presenters/sidebar/SidebarPresenter"));
const TrackListPresenter_1 = __importDefault(require("./presenters/tracklist/TrackListPresenter"));
const PlayerPresenter_1 = __importDefault(require("./presenters/player/PlayerPresenter"));
const createAndAppendElement_1 = require("./utils/dom/createAndAppendElement");
const TracksModel_1 = __importDefault(require("./model/TracksModel"));
const PlaylistsPresenter_1 = __importDefault(require("./presenters/playlists/PlaylistsPresenter"));
const ScreenPresenter_1 = __importDefault(require("./presenters/screen/ScreenPresenter"));
const PlaylistsModel_1 = __importDefault(require("./model/PlaylistsModel"));
const ScreenState_1 = require("./types/ScreenState");
const axios_1 = __importDefault(require("axios"));
const auth_1 = require("./api/auth");
const tracks_1 = require("./api/tracks");
const DropdownService_1 = __importDefault(require("./utils/services/DropdownService"));
const ModalService_1 = __importDefault(require("./utils/services/ModalService"));
const ModelStatus_1 = require("./types/ModelStatus");
const TracksType_1 = require("./types/TracksType");
const PlayerModel_1 = __importDefault(require("./model/PlayerModel"));
require("nouislider/dist/nouislider.css");
require("../node_modules/izitoast/dist/css/iziToast.min.css");
require("./resources/css/style.css");
const createLikeCallbackCreator_1 = require("./callbacks/createLikeCallbackCreator");
const createChangeToPlaylistCallback_1 = require("./callbacks/createChangeToPlaylistCallback");
const createLoadTracksCallback_1 = require("./callbacks/createLoadTracksCallback");
init();
async function init() {
    javascript_time_ago_1.default.addDefaultLocale(ru_1.default);
    const authToken = await (0, auth_1.getApiToken)();
    axios_1.default.defaults.headers.common.Authorization = `Bearer ${authToken}`;
    const rootElement = (0, createRootElement_1.createRootElement)();
    const dropdownService = new DropdownService_1.default();
    const modalService = new ModalService_1.default();
    const tracksModel = new TracksModel_1.default();
    tracksModel.setAll(await (0, tracks_1.loadTracks)(''));
    tracksModel.status = ModelStatus_1.ModelStatus.Success;
    const firstSong = tracksModel.allWithSearch()[0];
    if (!firstSong) {
        throw new Error('firstSong is not found');
    }
    const playerModel = new PlayerModel_1.default(firstSong, tracksModel.all());
    const playlistsModel = new PlaylistsModel_1.default();
    initPresenters(rootElement, tracksModel, playlistsModel, playerModel, dropdownService, modalService);
}
function initPresenters(rootElement, tracksModel, playlistsModel, playerModel, dropdownService, modalService) {
    // Create presenters and DOM elements for them
    const headerPresenter = new HeaderPresenter_1.default(rootElement, tracksModel);
    const contentWrapElement = (0, createAndAppendElement_1.createAndAppendElement)(rootElement, '<div class="content-wrap flex"></div>');
    const sidebarPresenter = new SidebarPresenter_1.default(contentWrapElement, playlistsModel, tracksModel);
    const mainElement = (0, createAndAppendElement_1.createAndAppendElement)(contentWrapElement, '<main class="main"> </main>');
    const trackListPresenter = new TrackListPresenter_1.default(mainElement, tracksModel, playlistsModel, playerModel, dropdownService, modalService);
    const playlistsPresenter = new PlaylistsPresenter_1.default(mainElement, playlistsModel, modalService);
    const screenPresenter = new ScreenPresenter_1.default(mainElement, trackListPresenter, playlistsPresenter);
    const playerPresenter = new PlayerPresenter_1.default(rootElement, playerModel, tracksModel, (0, createLikeCallbackCreator_1.createLikeCallbackCreator)(playerModel, tracksModel));
    // Create callbacks
    const changeToPlaylist = (0, createChangeToPlaylistCallback_1.createChangeToPlaylistCallback)(tracksModel, sidebarPresenter);
    const loadTracksCallback = (0, createLoadTracksCallback_1.createLoadTracksCallback)(tracksModel);
    const searchChangeCallback = () => {
        if (screenPresenter.currentScreen !== ScreenState_1.ScreenState.Playlists) {
            if (tracksModel.tracksType === TracksType_1.TracksType.Tracks) {
                loadTracksCallback();
            }
            screenPresenter.render();
        }
    };
    // Add callbacks to presenters
    headerPresenter.searchChangeCallback = searchChangeCallback;
    headerPresenter.render();
    sidebarPresenter.loadTracksCallback = loadTracksCallback;
    sidebarPresenter.changeToPlaylist = changeToPlaylist;
    sidebarPresenter.searchChangeCallback = searchChangeCallback;
    playlistsPresenter.changeToPlaylist = changeToPlaylist;
    trackListPresenter.createLikeCallback = (0, createLikeCallbackCreator_1.createLikeCallbackCreator)(playerModel, tracksModel);
    // Create callbacks for models
    tracksModel.onChange = (state) => {
        tracksModel.filterString = '';
        headerPresenter.render();
        sidebarPresenter.render();
        screenPresenter.changeScreen(state);
    };
    tracksModel.onUpdate = (state) => {
        screenPresenter.changeScreen(state);
    };
    playlistsModel.onChange = () => {
        sidebarPresenter.render();
        screenPresenter.render();
    };
    playerModel.onTrackInfoChange = (trackData) => {
        if (playerModel.track.id === trackData.id) {
            const index = playerModel.track.index;
            playerModel.track = trackData;
            playerModel.track.index = index;
            playerPresenter.render();
        }
        tracksModel.update(trackData, trackData.id);
        playlistsModel.updateTrack(trackData);
        screenPresenter.render();
    };
    playerModel.onTrackChange = () => {
        playerPresenter.load();
        playerPresenter.play();
    };
    playerModel.onTrackListChange = () => {
        playerPresenter.onTrackListChange();
    };
}
